module.exports = __webpack_public_path__ + "img/6_77.3fcf483b.png";